module.exports = __webpack_public_path__ + "img/chocolate.5b0fb3fe.svg";